import { Stack, TextField as MUITextField } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';

import FieldLabel from './FieldLabel';

function TextField({ label, tooltip, control, name, rules }) {
  return (
    <Stack spacing={1}>
      <FieldLabel label={label} tooltip={tooltip} />
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <MUITextField
            placeholder={label}
            error={!!error}
            helperText={error ? error.message : null}
            {...field}
          />
        )}
      />
    </Stack>
  );
}

export default TextField;
